<template>
  <ul class="Wdgt-Search-Results">
    <li v-for="result in props.results" :key="result.url" class="Wdgt-Search-Results__item">
      <AvatarImage v-if="result.logo" class="Wdgt-Search-Results__image" :src="result.logo" :size="24"
                   :alt="result.title"/>
      <div v-else class="Wdgt-Search-Results__image Wdgt-Search-Results__image--empty"></div>
      <a class="Wdgt-Search-Results__link"
         :href="result.url"
         target="_blank"
         rel="noopener noreferrer"
         v-html="result.title">
      </a>
      <span class="Wdgt-Search-Results__type">{{ result.section }}</span>
      <CounterComment
          class="Wdgt-Search-Results__comment"
          :count="result.comments_count"
          :type="'light'"
          :isClickable="true"
          @click="goToComments(result.url)"
      />
      <time class="Wdgt-Search-Results__time">{{ formatDate(result.publication_date) }}</time>
    </li>
  </ul>
</template>

<script setup>
import {defineProps, nextTick} from 'vue';
import {Props} from './scripts/props.js';
import {useStore} from 'vuex';
import {useRoute} from 'vue-router';
import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName.js';
//---------------------------------------
import CounterComment from '@ui/Counters/CounterComment/CounterComment.vue';
import AvatarImage from '@ui/Images/AvatarImage/AvatarImage.vue';
import ButtonMain from "@ui/Buttons/ButtonMain/ButtonMain.vue";
//---------------------------------------
const store = useStore();
const route = useRoute();
const props = defineProps(Props());
//---------------------------------------
//Форматирование даты
const formatDate = (dateString) => {
  const options = {year: 'numeric', month: 'short', day: 'numeric'};
  return new Date(dateString).toLocaleDateString('ru-RU', options);
};
//Открыть попап с контентом, изменить адрес без перехода на страницу
const toOpenContentPopup = async (url) => {
  store.dispatch('Dropdowns/removeTheDropdown', DROPDOWN_NAMES.contentPage);
  await nextTick();
  toChangeUrl(url);
  store.dispatch('Dropdowns/addNewDropdown', DROPDOWN_NAMES.contentPage);
};
//Переместить к комментариям
const goToComments = (url) => {
  toChangeUrl(url);
  store.commit('ContentSystem/Comments/setScrollTarget', {
    isComments: true,
    idComment: null,
    context: 'popupComments',
    isFocusStart: true,
  });
  store.dispatch('Dropdowns/addNewDropdown', DROPDOWN_NAMES.contentPage);
}
//Обновить адрес в строке поиска и запомнить последний урл перед переходом
const toChangeUrl = (url) => {
  store.commit('ContentSystem/toRememberLastPageUrl', route.path);
  window.history.pushState({}, '', window.location.href);
  window.history.replaceState({}, '', url);
};
</script>

<style lang="scss">
@import "./styles/_conf";
</style>
